import React, { useLayoutEffect, useState } from 'react';
import { connect } from 'react-redux';
import { _, isEmpty } from 'lodash';
import { bindActionCreators } from 'redux';
import { getStoreThemeUrl } from '@reducers/theme';
import Orders from '@components/Orders';
import cloneDeep from 'lodash/cloneDeep';
import EventEmitter from '@utility/eventSubscribers';
import {
  clearAuthResponse
} from '@reducers/payment';
import {
  getMenu,
  pushMenuItemsByScreenId,
  pushCartItemsInfo,
  replaceCart,
  onSearchItem,
  upsellCheck,
  addToCart,
  removeItemFromCart,
  pushItemQuantityToCart,
  changeMenu,
  orderItems,
  updateMultiCart,
  removeSeat,
  clearMenu,
  editCartItem,
  setSeat,
  clearCart,
  setPosition,
  addToChecks,
  addChecks,
  deleteItm,
  deleteAllItems,
  sendAllItem,
  singleSend,
  moveChecks,
  seatClear,
  pushCartItems,
  setPaymentCheck,
  updateCartAfterNote,
  updateCheckName,
  updateSeatInfo,
  setHighlightCartItems,
  voidItm,
  checkVoid,
  priceCheck,
  removePaymentCheck,
  enableStartOverBtn,
  openStartOrderPopUp
} from '@reducers/orders';
import {
  updateChecksAfterResponse,
  printing, syncCheckForPayment,
  updateCheckAfterPriceCheck,
} from '@reducers/storeChecks';
import uuidv4 from 'uuid/v4';
import { logout, openManagerCheck, setInActivityStatus } from '@reducers/oauth';
import { occupySeat } from '@reducers/checks';
import style from './menuorder.module.scss';
import { APP_CONFIG, SUCCESS_MESSAGE } from '@constants';
import {
  getObjectValue,
  urlSearchParams,
  mapStringCartToObject,
  renderExcludeModifier
} from '@utility/utills';
import Modal from '@components/common/Modal';
import { changeMenuByIndex } from '@reducers/browse';
import find from 'lodash/find';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import filter from 'lodash/filter';
import {
  setNotification, setPrintNotification, stopNotificationSound, closePrintNotification
} from '@reducers/notification';
import cn from 'classnames';
import { sort } from '@utility/helperFunction';
import { flowType } from '@utility/userInfo';
import Search from '@components/common/search';
import SearchComponent from '@components/common/search/SearchComponent';
import KeyboardInput from '@components/common/formElements/KeyboardInput/keyboardInput';
import { Formik, Form } from 'formik';
import ManagerCheck from '@components/checksCommon/managerCheck';
import KioskCart from '@containers/KioskCart';

const MenuOrder = ({ loading, menuLoading, ...props }) => {
  const isLoaderRequried = true;
  const [showBtn, setShowBtn] = useState(0);
  const [search, onChangeSearch] = useState('');
  const [isClearPopUp, setClearPopUp] = useState(false);
  const [clearId, setClearId] = useState();
  const [keyboard, setKeyboard] = useState(() => { return 'seatNumber'; });
  const [isSelectedCard, setIsSelectedCard] = useState({
    menuItemId: '',
    open: false
  });
  const [setDeletePopUp, deletePop] = useState(false);
  const [openMovePopUp, setOpenMovePopUp] = useState(false);
  const [currentSwipedSeats, setCurrentSwipedSeats] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  const [isCheckNameModalOpen, setIsCheckNameModalOpen] = useState(false);
  const isServerApp = flowType() === 'serverApp';
  const isKiosk = flowType() === 'kiosk';
  const isTableTop = flowType() === 'tableTop';
  const [tabName, setTabName] = useState(getObjectValue(() => props.check.tabName, ''));
  const [voidItemData, setVoidItemData] = useState('');
  const [isVoidOpen, setIsVoidOpen] = useState(false);
  const [cancelOrderConfirm, setCancelOrderConfirm] = useState(false);
  const isDefaultMode = getObjectValue(() => (!props.deviceInfo.deviceGroup || [0].includes(props.deviceInfo.deviceGroup.startMode)), false);
  const isCounter = getObjectValue(() => isServerApp && [1].includes(props.deviceInfo.deviceGroup.startMode), false);
  const isOrderPayMode = getObjectValue(() => isTableTop && [1].includes(props.deviceInfo.deviceGroup.startMode), false);

  const getMenuItem = (screenId) => {
    onChangeSearch('');
    window.scrollTo(0, 0);
    props.pushMenuItemsByScreenId(screenId);
  };
  const geItemQuantity = (cart) => {
    let count = 0;
    (cart || []).forEach(() => {
      count += 1;
    });
    return count;
  };

  const goToChecks = () => {
    setCancelOrderConfirm(false);
    if (isCounter || isOrderPayMode) {
      const dataToSend = {
        employeeId: Number(props.userInfo.id),
        storeId: props.deviceInfo.storeId,
        checkHeaderId: props.check.id,
        deviceId: props.deviceInfo.deviceId,
      };
      props.checkVoid(dataToSend).then((res) => {
        props.updateChecksAfterResponse(res);
        props.history.replace({
          pathname: `${APP_CONFIG.BASE_URL}/${flowType()}/checks`,
        });
      }).catch((e) => {
        props.setNotification({
          type: 'danger',
          message: e.message
        });
      });
    } else {
      props.history.replace({
        pathname: `${APP_CONFIG.BASE_URL}/${flowType()}/checks`,
      });
    }
  };

  const handleCancelOrderConfirm = () => {
    if (isCounter || isOrderPayMode) {
      setCancelOrderConfirm(true);
    } else {
      goToChecks();
    }
  };

  const getCartInfoForLinkedItems = (itemsList) => {
    let count = 0;
    (itemsList || []).forEach((linkedMenuItem) => {
      if (props.cartItemsInfo[linkedMenuItem.linkedMenuItemId]) {
        count += geItemQuantity(props.cartItemsInfo[linkedMenuItem.linkedMenuItemId]);
      }
    });
    return count;
  };

  const goToCart = () => {
    props.history.replace(`${APP_CONFIG.BASE_URL}/kiosk/cart`);
  };

  const calculateModifierAmount = (modifierData) => {
    let modiferPrice = 0;
    const modifierObject = mapStringCartToObject([{ modifiers: modifierData }], []);
    const getModifierAmount = (modifierList) => {
      modifierList.forEach((mod) => {
        modiferPrice += (mod.quantity * Number(_.find(props.modifierGroupsHashTable[mod.modifierGroupId].modifierLinks, (d) => d.modifierId === Number(mod.modifierId)).price));
        if (mod.modifiers) {
          getModifierAmount(mod.modifiers);
        }
      });
    };
    getModifierAmount(modifierObject[0].modifiers);
    return modiferPrice;
  };

  const renderInitialData = (menuItemId) => {
    const modifierList = props.menuItemsHashTable[menuItemId].modifierGroupLinks.map((item) => ({
      ...item,
      ...props.modifierGroupsHashTable[item.modifierGroupId]
    }));
    const preSelectModList = [];
    modifierList.forEach((modGroup) => {
      if (modGroup.hiddenMenuId === props.activeMenuItemId && modGroup.hiddenAutoAddModifierId && props.modifiersHashTable[modGroup.hiddenAutoAddModifierId]) {
        preSelectModList.push(`${modGroup.hiddenAutoAddModifierId}-${modGroup.id}`);
      } else {
      }
    });
    return preSelectModList;
  };

  const updateExcludeModifier = (cartItemsList) => {
    const cartTemp = cloneDeep(cartItemsList);
    cartTemp.forEach((cartItem) => {
      renderExcludeModifier(props.menuItemsHashTable[cartItem.menuItemId].modifierGroupLinks, cartItem, props.modifierGroupsHashTable, props.modifiersHashTable, '');
      if (cartItem && cartItem.modifier && cartItem.modifiers.length > 0) {
        cartItem.modifiers.filter((d) => (d.includes('|') && !d.includes('-0'))).forEach((d) => {
          renderExcludeModifier(props.modifiersHashTable[d.split('|')[0].split('-')[0]].modifierGroupLinks, cartItem, props.modifierGroupsHashTable, props.modifiersHashTable, `${d.split('|')[0]}|`);
        });
      }
    });
    return cartTemp;
  };
  const applyModFunction = (cartItemsList) => {
    cartItemsList.forEach((cartItem) => {
      if (cartItem.modifiers && cartItem.modifiers.length > 0) {
        cartItem.modifiers.forEach((modifier) => {
          modifier.split('|').forEach((mod, i) => {
            if (mod.split('-')[1] && (props.modifierGroupsHashTable[mod.split('-')[1]] || {}).applyModFunction) {
              if (i === 0 && !cartItem.modifiers.includes(`${mod}|${props.modifierGroupsHashTable[mod.split('-')[1]].modFunctionModifierId}-${props.modifierGroupsHashTable[mod.split('-')[1]].modFunctionModifierGroupId}`)) {
                cartItem.modifiers.push(`${mod}|${props.modifierGroupsHashTable[mod.split('-')[1]].modFunctionModifierId}-${props.modifierGroupsHashTable[mod.split('-')[1]].modFunctionModifierGroupId}`);
              } else if (!cartItem.modifiers.includes(`${modifier}|${props.modifierGroupsHashTable[mod.split('-')[1]].modFunctionModifierId}-${props.modifierGroupsHashTable[mod.split('-')[1]].modFunctionModifierGroupId}`)) {
                cartItem.modifiers.push(`${modifier}|${props.modifierGroupsHashTable[mod.split('-')[1]].modFunctionModifierId}-${props.modifierGroupsHashTable[mod.split('-')[1]].modFunctionModifierGroupId}`);
              }
            }
          });
        });
      }
    });
    return cartItemsList;
  };

  const handleonAddToCart = (menuItemId, menuTypeId, dir, price, seatId) => {
    if (dir === 'inc') {
      const itemInfo = props.menuCard[menuTypeId][menuItemId];
      const dataToSend = {
        quantity: 1,
        price: price || itemInfo.price,
        menuItemId,
        menuTypeId,
        modifiers: renderInitialData(menuItemId),
        note: null,
        menuItemName: (itemInfo.menuItem || {}).name,
      };
      let cartItem = updateExcludeModifier([dataToSend]);
      cartItem = applyModFunction(cartItem);
      const modifierObject = getObjectValue(() => mapStringCartToObject(cartItem, [], props.modifiersHashTable, props.modifierGroupsHashTable)[0].modifiers, []);
      dataToSend.modifierObject = modifierObject.filter((e) => e.modifierGroupId);
      const modiferPrice = calculateModifierAmount([]);
      const requestData = {
        ...dataToSend,
        note: dataToSend.note,
        pending: true,
        seatIds: seatId || (props.position.number === -1 ? [] : [props.position.seatId]),
        price: Number(dataToSend.price) + modiferPrice,
        menuScreenId: Number(props.match.params.menuTypeId),
        internalId: new Date().getTime(),
        menuId: props.menusList[props.menuIndex].id,
        modifiers: dataToSend.modifierObject,
        modifierData: dataToSend.modifiers,
      };
      requestData.modifierJson = JSON.stringify({ ...requestData, openPrice: price > 0, });
      const dataToSendToAdd = {
        storeId: props.deviceInfo.storeId,
        employeeId: Number(props.userInfo.id),
        deviceId: props.deviceInfo.deviceId,
        checkHeaderId: props.check.id,
        employeeCard: props.userInfo.employeeCard,
        items: [requestData],
        orderJson: JSON.stringify(requestData),
        longitude: '0',
        latitude: '0',
        geoLocation: '0'
      };
      props.addChecks(dataToSendToAdd, 'add', isLoaderRequried).then((res) => {
        props.updateChecksAfterResponse(res);
        props.setSeat(res);
        const responseObj = getObjectValue(() => res.orders[0], []).items[res.orders[0].items.length - 1];
        const cartData = {
          ...requestData,
          openPrice: price > 0,
          id: responseObj.id,
          checkItemId: responseObj.checkItemId
        };
        props.addToCart(cartData);
      }).catch((e) => {
        props.setNotification({
          type: 'danger',
          message: e.message
        });
      });
    } else {
      let isSameModifier = true;
      for (let i = 0; i < props.cartItemsInfo[menuItemId].length; i += 1) {
        if (!_.isEqual(props.cartItemsInfo[menuItemId][0].modifiers, props.cartItemsInfo[menuItemId][i].modifiers) || !_.isEqual(props.cartItemsInfo[menuItemId][0].quantity, props.cartItemsInfo[menuItemId][i].quantity)) {
          isSameModifier = false;
          break;
        }
      }
      if (isSameModifier) {
        props.removeItemFromCart(props.cartItemsInfo[menuItemId]);
        props.pushCartItemsInfo();
      } else {
        setIsSelectedCard({ open: true, menuItemId });
      }
    }
  };

  const handleImmediateOrder = (menuItemId, menuTypeId, dir, price) => {
    if (dir === 'inc') {
      handleonAddToCart(menuItemId, menuTypeId, 'inc', price);
    }
  };

  const checkRequiredModifierCount = (menuItemId, menuId) => {
    const requiredModifierList = [];
    props.menuItemsHashTable[menuItemId].modifierGroupLinks.forEach((item) => {
      if (props.modifierGroupsHashTable[item.modifierGroupId].minimum > 0 && (props.modifierGroupsHashTable[item.modifierGroupId].hiddenMenuId !== menuId)) {
        requiredModifierList.push({
          ...item
        });
      }
      if (props.modifierGroupsHashTable[item.modifierGroupId].flowRequired) {
        requiredModifierList.push({
          ...item
        });
      }
    });
    return requiredModifierList.length;
  };

  const pushToOrder = (menuItemId, menuTypeId, type, price, quickOrder, dir) => {
    window.sessionStorage.setItem('scrol', window.pageYOffset, 'quickOrder', quickOrder);
    window.sessionStorage.setItem('menuTypeId', menuTypeId);
    const itemCount = geItemQuantity(props.cartItemsInfo[menuItemId]);
    const orderType = props.cartItemsInfo[menuItemId] && props.cartItemsInfo[menuItemId].length > 0 ? 'orderAnother' : 'order';
    if (quickOrder && !getObjectValue(() => props.menuCard[menuTypeId][menuItemId].menuItem.outOfStock, false)) {
      const requiredModLength = checkRequiredModifierCount(menuItemId, props.menusList[props.menuIndex].id);
      if (getObjectValue(() => props.menuCard[menuTypeId][menuItemId].menuItem.modifierGroupLinks.length, 2) === 0 && !dir) {
        handleImmediateOrder(menuItemId, menuTypeId, 'inc', price);
      } else if (requiredModLength === 0 && !dir) {
        handleonAddToCart(menuItemId, menuTypeId, 'inc', price);
      } else if (requiredModLength > 0 && !dir) {
        props.history.push(`${APP_CONFIG.BASE_URL}/kiosk/order-item/${menuTypeId}/${menuItemId}?menuId=${props.menusList[props.menuIndex].id}&orderType=${orderType}`);
      } else {
        handleonAddToCart(menuItemId, menuTypeId, dir, price);
      }
    } else if (getObjectValue(() => props.menuCard[menuTypeId][menuItemId].menuItem.linkType, 0) === 1 && type === 1 && getCartInfoForLinkedItems(props.menuCard[menuTypeId][menuItemId].menuItem.links) === 1) {
      props.menuCard[menuTypeId][menuItemId].menuItem.links.forEach((d) => {
        if (props.cartItemsInfo[d.linkedMenuItemId]) {
          const linkedMenuInfo = props.cartItemsInfo[d.linkedMenuItemId][0];
          props.history.push(`${APP_CONFIG.BASE_URL}/kiosk/order-item/${linkedMenuInfo.menuTypeId}/${linkedMenuInfo.menuItemId}/${linkedMenuInfo.internalId}/0?menuId=${linkedMenuInfo.menuId}&backTo=orders`);
        }
      });
    } else if (getObjectValue(() => props.menuCard[menuTypeId][menuItemId].menuItem.linkType, 0) === 1 && type === 1 && getCartInfoForLinkedItems(props.menuCard[menuTypeId][menuItemId].menuItem.links) > 1) {
      props.history.push(`${APP_CONFIG.BASE_URL}/selected-cart/${menuItemId}`);
    } else if (getObjectValue(() => props.menuCard[menuTypeId][menuItemId].menuItem.linkType, 0) === 1) {
      props.history.push(`${APP_CONFIG.BASE_URL}/kiosk/order-item/${menuTypeId}/${menuItemId}?menuId=${props.menusList[props.menuIndex].id}&parentMenuItemId=${menuItemId}`);
    } else if (getObjectValue(() => props.menuCard[menuTypeId][menuItemId].menuItem.modifierGroupLinks.length, 2) === 0 && !getObjectValue(() => props.menuCard[menuTypeId][menuItemId].menuItem.outOfStock, false) && type !== 1) {
      handleImmediateOrder(menuItemId, menuTypeId, 'inc', price);
    } else if (itemCount === 1 && type === 1) {
      const internalId = props.cartItemsInfo[menuItemId][0].internalId;
      props.history.push(`${APP_CONFIG.BASE_URL}/kiosk/order-item/${menuTypeId}/${menuItemId}/${internalId}/0?menuId=${props.menusList[props.menuIndex].id}&backTo=orders`);
    } else if (itemCount > 1 && type === 1) {
      props.history.push(`${APP_CONFIG.BASE_URL}/selected-cart/${menuItemId}`);
    } else {
      const requiredModLength = checkRequiredModifierCount(menuItemId, props.menusList[props.menuIndex].id);
      if (requiredModLength === 0) {
        handleonAddToCart(menuItemId, menuTypeId, 'inc', price);
      } else {
        props.history.push(`${APP_CONFIG.BASE_URL}/kiosk/order-item/${menuTypeId}/${menuItemId}?menuId=${props.menusList[props.menuIndex].id}&orderType=${orderType}`);
      }
    }
  };

  const orderDetailRoute = (menuItemId, menuTypeId, items, orderType) => {
    const linkType = getObjectValue(() => props.menuCard[menuTypeId][menuItemId].menuItem.linkType, 0);
    switch (orderType) {
      case 'orderAnother':
      case 'order': {
        if (linkType === 1) {
          props.history.push(`${APP_CONFIG.BASE_URL}/kiosk/order-item/${menuTypeId}/${menuItemId}?menuId=${props.menusList[props.menuIndex].id}&parentMenuItemId=${menuItemId}`);
        }
        if (linkType !== 1) {
          props.history.push(`${APP_CONFIG.BASE_URL}/kiosk/order-item/${menuTypeId}/${menuItemId}?menuId=${props.menusList[props.menuIndex].id}&orderType=${orderType}`);
        }
        break;
      }
      case 'modify': {
        if (items.length > 1) {
          setIsSelectedCard({ open: true, menuItemId });
        } else {
          const internalId = items[0].internalId;
          const checkItemId = items[0].id;
          props.history.push(`${APP_CONFIG.BASE_URL}/kiosk/order-item/${menuTypeId}/${menuItemId}/${internalId}/1?menuId=${props.menusList[props.menuIndex].id}&checkItem=${checkItemId}&type=edit`);
        }
        break;
      }
      default:
        break;
    }
  };
  const checkItemPresent = (data, type) => {
    let itemPresent = true;
    if (type === 'repeatSent') {
      itemPresent = data.every((d) => props.check.orders[0].items.some((item) => item.checkItemId === d.id));
    }
    return itemPresent;
  };

  const openPriceEdit = (data) => {
    const itemInfo = props.menuCard[data.menuTypeId][data.menuItemId];
    const dataToSend = {
      quantity: 1,
      price: data.price || itemInfo.price,
      menuItemId: data.menuItemId,
      menuTypeId: data.menuTypeId,
      modifiers: renderInitialData(data.menuItemId),
      internalId: data.internalId,
      note: null,
      menuItemName: (itemInfo.menuItem || {}).name,
    };
    let cartItem = updateExcludeModifier([dataToSend]);
    cartItem = applyModFunction(cartItem);
    const modifierObject = getObjectValue(() => mapStringCartToObject(cartItem, [], props.modifiersHashTable, props.modifierGroupsHashTable)[0].modifiers, []);
    dataToSend.modifierObject = modifierObject.filter((e) => e.modifierGroupId);
    const modiferPrice = calculateModifierAmount([]);
    const requestData = {
      ...dataToSend,
      note: dataToSend.note,
      pending: true,
      seatIds: data.seatIds,
      price: Number(dataToSend.price) + modiferPrice,
      menuScreenId: data.menuTypeId,
      menuId: props.menusList[props.menuIndex].id,
      modifiers: dataToSend.modifierObject,
      modifierData: dataToSend.modifiers,
    };
    requestData.modifierJson = JSON.stringify({ ...requestData, openPrice: Number(data.price) > 0 });
    const itemInfoObj = {
      ...requestData,
      seatIds: data.seatIds,
      modifiers: dataToSend.modifierObject,
      suppressNote: false,
      ageRestricted: false,
      checkOrderItemId: data.id
    };
    const dataToSendToAdd = {
      storeId: props.deviceInfo.storeId,
      employeeId: Number(props.userInfo.id),
      deviceId: props.deviceInfo.deviceId,
      checkHeaderId: props.check.id,
      employeeCard: props.userInfo.employeeCard,
      items: [itemInfoObj],
      orderJson: JSON.stringify(itemInfoObj),
      longitude: '0',
      latitude: '0',
      geoLocation: '0'
    };
    props.addChecks(dataToSendToAdd, 'update').then((res) => {
      props.updateChecksAfterResponse(res);
      props.setSeat(res);
      const responseObj = getObjectValue(() => res.orders[0], []).items[res.orders[0].items.length - 1];
      const cartData = {
        ...requestData,
        openPrice: data.price > 0,
        id: data.id,
        checkItemId: responseObj.checkItemId
      };
      props.editCartItem(cartData);
    }).catch((e) => {
      props.setNotification({
        type: 'danger',
        message: e.message
      });
    });
  };

  const onModifyItem = (data, type) => {
    if (type === 'repeatSent') {
      if (checkItemPresent([data], type)) {
        const cartItems = getObjectValue(() => props.check.orders[0].items, []).find((e) => e.checkItemId === data.id);
        const req = JSON.parse(JSON.parse(cartItems.orderJson).modifierJson);
        if (req.menuItemId && req.menuTypeId) {
          props.history.push(`${APP_CONFIG.BASE_URL}/order-item/${req.menuTypeId}/${req.menuItemId}/${req.internalId}/1?menuId=${req.menuId}&&checkItem=${req.id}&&type=${type}`);
        }
      }
    } else {
      props.setHighlightCartItems([data]);
      if (data.menuTypeId && data.menuItemId) {
        props.history.push(`${APP_CONFIG.BASE_URL}/order-item/${data.menuTypeId}/${data.menuItemId}/${data.internalId}/1?menuId=${data.menuId}&&checkItem=${data.id}&&seatId=${data.seatIds[0]}&&type=${type}`);
      }
    }
  };

  const handleClear = (data) => {
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      employeeId: Number(props.userInfo.id),
      employeeCard: props.userInfo.employeeCard,
      deviceId: props.deviceInfo.deviceId,
      checkHeaderId: props.check.id,
      stationId: props.check.stationId || null,
      seats: [{
        seatId: data.id
      }]
    };
    props.seatClear(dataToSend).then((res) => {
      props.setSeat(res);
      props.setPosition({ number: -1, position: -1 });
      props.updateChecksAfterResponse(res);
      setShowBtn(-1);
      props.setNotification({
        type: 'success',
        message: SUCCESS_MESSAGE.CLEAR_SEAT_SUCCESS,
      });
    }).catch((err) => {
      props.setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const handleVoidItems = () => {
    const dataToSend = {
      employeeId: Number(props.userInfo.id),
      storeId: props.deviceInfo.storeId,
      checkHeaderId: props.check.id,
      items: voidItemData.map((item) => {
        return {
          checkItemId: item.id
        };
      }),
    };
    props.voidItm(dataToSend).then((res) => {
      props.updateChecksAfterResponse(res);
      props.setSeat(res);
      props.setNotification({
        type: 'success',
        message: SUCCESS_MESSAGE.VOID_CHECK_SUCCESS
      });
    }).catch((err) => {
      props.setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const seatBtn = [{ name: LABEL().CLEAR, click: (item) => { setClearPopUp(true); setOpenMovePopUp(false); setClearId(item); } }];
  const [moveArray, setMoveArray] = useState([]);

  const getOrderSendModeType = (type) => {
    switch (type) {
      case 'toGo': return 1;
      case 'doNotMake': return 2;
      case 'onTheFly': return 3;
      case 'runner': return 4;
      default: return 0;
    }
  };

  const getLinkedMenuItemsId = (data, type) => {
    const menuList = [];
    data.forEach((item) => {
      if (!item.hasLinkedMenuItem) {
        menuList.push({ checkOrderItemId: item.id, orderSendMode: getOrderSendModeType(type) });
      } else {
        item.modifiers.forEach((e) => {
          const linkedIndex = props.cart.findIndex((d) => d.menuItemId === e.modifierId && d.uniqueIdForLinkedItem === item.uniqueIdForLinkedItem);
          if (linkedIndex > -1) {
            menuList.push({ checkOrderItemId: props.cart[linkedIndex].id, orderSendMode: getOrderSendModeType(type) });
          }
        });
        menuList.push({ checkOrderItemId: item.id, orderSendMode: getOrderSendModeType(type) });
      }
    });
    return menuList;
  };

  const deleteItem = (data) => {
    const datatosend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: props.check.id,
      employeeCard: props.userInfo.employeeCard,
      items: getLinkedMenuItemsId(data)
    };
    props.deleteItm(datatosend).then((res) => {
      props.updateChecksAfterResponse(res);
      props.setNotification({
        type: 'success',
        message: SUCCESS_MESSAGE.ITEM_DELETE_SUCCESS
      });
    }).catch(() => {
      props.setNotification({
        type: 'danger',
        message: SUCCESS_MESSAGE.ITEM_DELETE_FAIL
      });
    });
  };

  const onSearch = () => {
    if (search.length > 0) {
      props.onSearchItem(search);
    }
  };

  const onSearchChange = (string) => {
    if (!string) {
      if (window.sessionStorage.getItem('scrol') && window.sessionStorage.getItem('menuTypeId')) {
        props.pushMenuItemsByScreenId(Number(window.sessionStorage.getItem('menuTypeId')));
        window.scrollTo(0, window.sessionStorage.getItem('scrol'));
      }
    } else if (string.length > 2) {
      props.onSearchItem(string);
    }
    onChangeSearch(string);
  };

  const onRemoveItemFromCart = (internalId) => {
    props.removeItemFromCart(internalId);
    props.pushCartItemsInfo();
  };

  const navigateTo = (url) => {
    if (['/account', '/profile-feature'].includes(url)) {
      window.sessionStorage.setItem('footer', JSON.stringify(props.footer));
      window.sessionStorage.setItem('accountPageToRedirect', window.location.pathname);
    }
    props.history.push(`${APP_CONFIG.BASE_URL}${url}`);
  };

  const handleMenuChangeNavigation = () => {
    if (props.isBrowse) {
      props.history.push(`${APP_CONFIG.BASE_URL}/browse-category`);
    } else {
      props.history.push(`${APP_CONFIG.BASE_URL}/orders`);
    }
  };

  const handleSelectStore = () => {
    props.history.push(`${APP_CONFIG.BASE_URL}/pick-store`);
  };

  const handleKioskCheckout = () => {
    props.history.push(`${APP_CONFIG.BASE_URL}/kiosk/upsell`);
  };

  const addSeatData = (datas, identifier) => {
    const checkData = props.check;
    props.setHighlightCartItems([]);
    if (identifier === 'table') {
      props.setPosition({ number: -1, position: -1 });
      const pendingItems = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('seat')).orders[0].items, []).filter((e) => e.pending).map((d) => {
        let data = [];
        if (props.position.number !== -1) {
          data = Number(JSON.parse(d.orderJson).seatIds[0]) === datas.id ? JSON.parse(d.orderJson) : {};
        } else {
          data = JSON.parse(d.orderJson);
        }
        return data;
      });
      if (pendingItems.length > 0) {
      }
    } else {
      props.setPosition(datas);
      setShowBtn(datas.number);
      const itemsAssociated = filter(checkData.items, (item) => item.seats && find(item.seats, (seatSplit) => (seatSplit.seatId === datas.id)));
      for (let i = 0; i < itemsAssociated.length; i += 1) {
        const singleItm = find(itemsAssociated[i].seats, (singleItem) => singleItem.seatId === datas.id);
        itemsAssociated[i] = {
          ...itemsAssociated[i],
          price: singleItm.splitAmount,
        };
      }
      const pendingItems = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('seat')).orders[0].items, []).filter((e) => e.pending).map((d) => {
        let data = [];
        if (props.position.number !== -1) {
          data = Number(JSON.parse(d.orderJson).seatIds[0]) === datas.id ? JSON.parse(d.orderJson) : {};
        } else {
          data = JSON.parse(d.orderJson);
        }
        return data;
      });
      if (pendingItems.length > 0) {
      }
    }
  };


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [seats, setSeats] = useState(props.check);

  useLayoutEffect(() => {
    setSeats({
      ...props.check,
      seats: props.check?.seats ? sort(props.check.seats, 'number') : []
    });
    if (props.check?.seats && props.check.seats.length > 0 && Object.keys(props.position).length === 0) {
      const postionReq = props.check && props.check.seats && props.check.seats.length > 0 && props.check.seats.filter((e) => e.open)[0];
      props.setPosition(postionReq || { number: -1, position: -1 });
      setShowBtn(postionReq && postionReq.number ? postionReq.number : -1);
    } else if (Object.keys(props.position).length > 0) {
      setShowBtn(props.position.number);
    } else {
      addSeatData({}, 'table');
      setShowBtn(-1);
    }
  }, [props.position]);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const checkPendingItemsPresent = (data) => {
    return data && data.orders[0] && data.orders[0].items.some((item) => item.pending === true);
  };

  const getSubTotalAmount = (table) => {
    return props.auth.country === 1 ? +(table.itemAmount) : +(table.subTotalAmount);
  };

  const getTotalAmount = (table) => {
    const discount = getObjectValue(() => table.discountAmount, 0);
    const serviceCharge = getObjectValue(() => table.serviceChargeAmount, 0);
    return props.auth.country === 1 ? +(table.itemAmount + table.taxAmount + serviceCharge - discount) : +(table.itemAmount - discount);
  };

  const payRoute = () => {
    const dataToSend = {
      deviceId: props.deviceInfo.deviceId,
      employeeId: Number(props.userInfo.id),
      storeId: props.deviceInfo.storeId,
      checkHeaderId: props.check.id,
      paidAmount: props.check.paidAmount,
      unpaidAmount: Number(props.check.unpaidAmount),
      totalAmount: props.check.totalAmount
    };
    props.syncCheckForPayment(dataToSend).then((res) => {
      const data = res || props.check;
      props.setSeat({
        ...data,
        subTotalAmount: getSubTotalAmount(data),
        totalAmount: getTotalAmount(data)
      });
      const isPendingItemsPresent = checkPendingItemsPresent(data);
      if (isPendingItemsPresent && isServerApp) {
        props.setNotification({
          message: CUSTOM_MESSAGES().PAYMENT_ERROR_HAVING_UNSENT,
          type: 'danger'
        });
      } else {
     props.setPaymentCheck({
          ...data,
          subTotalAmount: getSubTotalAmount(data),
          totalAmount: getTotalAmount(data)
        }).then(() => {
          props.history.replace({ pathname: `${APP_CONFIG.BASE_URL}/receipt/${data.id}?ticketSplitTypeId=1&splitValue=1&screenType=1` });
        });
      }
    }).catch((err) => {
      props.setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const stageRoute = () => {
    const dataToSend = {
      deviceId: props.deviceInfo.deviceId,
      employeeId: Number(props.userInfo.id),
      storeId: props.deviceInfo.storeId,
      checkHeaderId: props.check.id,
      paidAmount: props.check.paidAmount,
      unpaidAmount: +(props.check.unpaidAmount),
      totalAmount: props.check.totalAmount
    };
    props.syncCheckForPayment(dataToSend).then((res) => {
      const data = res || props.check;
      props.setSeat({ ...data, subTotalAmount: getSubTotalAmount(data), totalAmount: getTotalAmount(data) });
      const isPendingItemsPresent = checkPendingItemsPresent(data);
      if (isPendingItemsPresent && isServerApp) {
        props.setNotification({
          message: CUSTOM_MESSAGES().PAYMENT_ERROR_HAVING_UNSENT,
          type: 'danger'
        });
      } else {
        props.setPaymentCheck({ ...data, subTotalAmount: getSubTotalAmount(data), totalAmount: getTotalAmount(data) }).then(() => {
          props.history.replace(({ pathname: `${APP_CONFIG.BASE_URL}/stage/${data.id}` }));
        });
      }
    }).catch((err) => {
      props.setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const speedOrderRouteToPay = () => {
    const data = getObjectValue(() => props.check.orders[0].items.reduce((a, v) => {
      if (v.pending) {
        a.push({
          ...v,
          ...JSON.parse(v.orderJson),
          menuScreenId: getObjectValue(() => JSON.parse(JSON.parse(v.orderJson).menuScreenId), 0),
          menuId: getObjectValue(() => JSON.parse(JSON.parse(v.orderJson).menuId), 0)
        });
      }
      return a;
    }, []), []);
    if (data && data.length > 0) {
      let subtotalAmount = 0;
      const items = data && data.length > 0 ? data.map((e) => {
        subtotalAmount += e.price;
        return {
          menuItemId: e.menuItemId,
          quantity: e.quantity,
          modifiers: e.modifiers,
          price: e.price,
          note: e.note,
          menuScreenId: e.menuScreenId,
          menuId: e.menuId
        };
      }) : [];
      const dataToSend = {
        deviceId: props.deviceInfo.deviceId,
        employeeId: Number(props.userInfo.id),
        storeId: props.deviceInfo.storeId,
        checkHeaderId: props.check.id,
        items,
        subtotalAmount
      };
      props.priceCheck(dataToSend).then((resData) => {
        props.setSeat({
          ...props.check,
          ...resData,
          items: data,
          itemAmount: resData.subTotalAmount,
          totalAmount: getTotalAmount({ ...resData, itemAmount: resData.subTotalAmount })
        });
        props.updateCheckAfterPriceCheck({
          ...props.check,
          ...resData,
        });
        props.setPaymentCheck({
          ...props.check,
          ...resData,
          items: data,
          itemAmount: resData.subTotalAmount,
          totalAmount: getTotalAmount({ ...resData, itemAmount: resData.subTotalAmount })
        }).then(() => {
          props.history.replace({ pathname: `${APP_CONFIG.BASE_URL}/receipt/${props.check.id}?ticketSplitTypeId=1&splitValue=1&screenType=1` });
        });
      }).catch((err) => {
        props.setNotification({
          type: 'danger',
          message: err.message
        });
      });
    } else {
      props.setNotification({
        message: CUSTOM_MESSAGES().NO_ITEM_MSG,
        type: 'danger'
      });
    }
  };

  const handleRoute = (type) => {
    switch (type) {
      case 'speedPay': speedOrderRouteToPay(); break;
      case 'pay': payRoute(); break;
      case 'stage': stageRoute(); break;
      default:
        break;
    }
  };

  const move = () => {
    setOpenMovePopUp(true);
    setClearId();
  };

  const printPopUp = () => {
    setOpenMovePopUp(true);
    setClearId();
  };

  const validateSeatNumber = (val) => {
    const isSeat = props.check.seats.find((item) => (item.open && item.number === Number(val.seatNumber)));
    const error = {};
    if (isEmpty(val.seatNumber)) {
      error.seatNumber = 'Enter Seat Number';
    } else if (isSeat) {
      error.seatNumber = 'Seat Number Already Taken';
    }
    return error;
  };

  const setOpenMovePop = () => {
    setOpenMovePopUp(false);
  };

  const sendSingle = (data, type) => {
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      employeeId: Number(props.userInfo.id),
      deviceId: props.deviceInfo.deviceId,
      checkHeaderId: props.check.id,
      employeeCard: props.userInfo.employeeCard,
      items: getLinkedMenuItemsId(data, type)
    };
    props.singleSend(dataToSend).then((res) => {
      props.updateChecksAfterResponse(res);
      props.setNotification({
        type: 'success',
        message: SUCCESS_MESSAGE.SENT_ITEM_SUCCESS
      });
    }).catch((err) => {
      props.setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const print = (array) => {
    const newArray = [...new Set(array)];
    let seatId = [];
    if (newArray.includes(-1)) {
      seatId = [];
    } else {
      seatId = [];
      newArray.forEach((e) => {
        props.check.seats.forEach((d) => {
          if (d.open && e === d.number) {
            seatId.push(d.id);
          }
        });
      });
    }
    const dataToSend = {
      deviceId: props.deviceInfo.deviceId,
      employeeId: Number(props.userInfo.id),
      employeeCard: props.userInfo.employeeCard,
      storeId: props.deviceInfo.storeId,
      checkHeaderId: seats.id,
      seatIds: seatId
    };
    props.printing(dataToSend).then((res) => {
      if (window.ReactNativeWebView) {
        EventEmitter.print(res);
      }
      props.setPrintNotification(res);
    }).catch((e) => {
      props.setNotification({
        type: 'danger',
        message: e.message
      });
    });
  };

  const printListener = (data) => {
    if (data.type === 'error') {
      props.setNotification({
        type: 'danger',
        message: data.message
      });
    } else {
      props.setNotification({
        type: 'success',
        message: data.message
      });
      props.closePrintNotification();
    }
  };

  useLayoutEffect(() => {
    props.enableStartOverBtn(true);
    if (window.ReactNativeWebView) {
      try {
        EventEmitter.printData((res) => {
          printListener(res);
        },
        (err) => {
          props.setNotification({
            type: 'danger',
            message: err
          });
        });
      } catch (e) {
        console.log('catch', e);
      }
    }
  }, []);

  const goToPayment = () => {
    props.history.replace('/pay');
  };

  const moveClick = (data, array, type) => {
    let seatId;
    if (array.includes(-1)) {
      seatId = [];
    } else {
      seatId = [];
      array.forEach((e) => {
        props.check.seats.forEach((d) => {
          if (d.open && e === d.number) {
            seatId.push(d.id);
          }
        });
      });
    }
    let dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: Number(props.userInfo.id),
      employeeCard: props.userInfo.employeeCard,
      checkHeaderId: seats.id,
      stationId: seats.stationId,
    };
    let selectedItems = {};
    props.setHighlightCartItems([]);
    switch (type) {
      case 'sent': dataToSend = {
        ...dataToSend,
        seatIds: seatId,
        checkItemSeats: data.map((e) => {
          return {
            checkItemId: e.id
          };
        }),
        checkDiscountSeats: [],
        checkServiceChargeSeats: [],
      };
        break;
      case 'unsent': selectedItems = getObjectValue(() => props.check.orders[0].items, []).reduce((a, v) => {
        if (data.some((d) => d.id === v.id)) {
          const item = JSON.parse(v.orderJson);
          const modifierJson = JSON.parse(item.modifierJson);
          a.push({
            ...item,
            seatIds: seatId,
            modifierJson: JSON.stringify({ ...modifierJson, seatIds: seatId }),
            checkOrderItemId: v.id,
          });
        }
        return a;
      }, []);
        dataToSend = {
          ...dataToSend,
          checkHeaderId: props.check.id,
          items: selectedItems,
          orderJson: JSON.stringify(selectedItems),
          longitude: '0',
          latitude: '0',
          geoLocation: '0'
        };
        props.addChecks(dataToSend, 'update').then((res) => {
          props.updateChecksAfterResponse(res);
          const updatedCart = props.cart.reduce((a, v) => {
            const foundIndex = data.findIndex((e) => e.id === v.id);
            if (foundIndex !== -1) {
              a.push({
                ...v,
                seatIds: seatId
              });
            } else {
              a.push({
                ...v,
              });
            }
            return a;
          }, []);
          props.updateCartAfterNote(updatedCart);
          props.setNotification({
            type: 'success',
            message: SUCCESS_MESSAGE.MOVE_CHECK_SUCCESS
          });
        }).catch((err) => {
          props.setNotification({
            type: 'danger',
            message: err.message
          });
        }); break;
      case 'discount': dataToSend = {
        ...dataToSend,
        seatIds: seatId,
        checkItemSeats: [],
        checkDiscountSeats: data.map((item) => {
          return {
            checkDiscountId: item.id
          };
        }),
        checkServiceChargeSeats: [],
      };
        break;
      case 'service': dataToSend = {
        ...dataToSend,
        seatIds: seatId,
        checkItemSeats: [],
        checkDiscountSeats: [],
        checkServiceChargeSeats: data.map((item) => {
          return {
            checkServiceChargeId: item.id
          };
        }),
      };
        break;

      default: break;
    }
    if (type !== 'unsent') {
      props.moveChecks(dataToSend).then((res) => {
        props.updateChecksAfterResponse(res);
        const updatedCart = props.cart.reduce((a, v) => {
          const foundIndex = data.findIndex((e) => e.id === v.id);
          if (foundIndex !== -1) {
            a.push({
              ...v,
              seatIds: seatId
            });
          } else {
            a.push({
              ...v,
            });
          }
          return a;
        }, []);
        props.updateCartAfterNote(updatedCart);
        props.setNotification({
          type: 'success',
          message: SUCCESS_MESSAGE.MOVE_CHECK_SUCCESS
        });
      }).catch((err) => {
        props.setNotification({
          type: 'danger',
          message: err.message
        });
      });
    }
  };

  const submitSeatNumber = (val) => {
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: Number(props.userInfo.id),
      employeeCard: props.userInfo.employeeCard,
      checkHeaderId: seats.id,
      seats: [
        {
          number: val.seatNumber,
          tableShareType: 0
        }
      ]
    };
    props.occupySeat(dataToSend).then((response) => {
      props.updateChecksAfterResponse(response);
      props.setNotification({
        type: 'success',
        message: SUCCESS_MESSAGE.NEW_SEAT_CRESTION_SUCCESS
      });
      const seatsData = filter((response.seats), (seat) => seat.open);
      const positionReq = find(seatsData, (seat) => seat.position === Number(dataToSend.seats[0].position));
      setShowBtn(positionReq.number);
      const seatReq = {
        ...response.checkHeader,
        seats: sort(response.seats, 'number')
      };
      props.setPosition(positionReq).then(() => {
        setSeats(seatReq);
        props.setSeat(seatReq);
      });
      setKeyboard('');
      closeModal();
    }).catch((err) => {
      setKeyboard('');
      props.setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const deleteAllPopUp = () => {
    setDeletePopUp(true);
  };

  const closeDeleteAllPopup = () => {
    setDeletePopUp(false);
  };

  const setSelectedToMove = (seat) => {
    if (!moveArray.includes(seat)) {
      moveArray.push(seat);
      setMoveArray(moveArray);
    }
  };

  const deleteAll = () => {
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      employeeId: Number(props.userInfo.id),
      deviceId: props.deviceInfo.deviceId,
      checkHeaderId: props.check.id,
      employeeCard: props.userInfo.employeeCard,
      items: props.cart.map((e) => {
        return { checkOrderItemId: e.id };
      })
    };
    props.deleteAllItems(dataToSend).then((res) => {
      props.updateChecksAfterResponse(res);
      props.setNotification({
        type: 'success',
        message: SUCCESS_MESSAGE.ITEM_DELETE_SUCCESS_MULTIPLE
      });
    }).catch((err) => {
      props.setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const startOrderPopUp = () => {
    props.openStartOrderPopUp(false);
  };

  const sendAllItems = (type) => {
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      employeeId: Number(props.userInfo.id),
      deviceId: props.deviceInfo.deviceId,
      checkHeaderId: props.check.id,
      employeeCard: props.userInfo.employeeCard,
      items: props.cart.map((e) => {
        return { checkOrderItemId: e.id, orderSendMode: getOrderSendModeType(type) };
      })
    };
    props.sendAllItem(dataToSend).then((res) => {
      props.updateChecksAfterResponse(res);
      props.setNotification({
        type: 'success',
        message: SUCCESS_MESSAGE.SENT_ITEM_SUCCESS_MULTIPLE
      });
    }).catch((err) => {
      props.setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const checkOut = (items) => {
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      employeeId: Number(props.userInfo.id),
      deviceId: props.deviceInfo.deviceId,
      checkHeaderId: props.check.id,
      employeeCard: props.userInfo.employeeCard,
      items: items.map((e) => {
        return { checkOrderItemId: e.id };
      })
    };
    props.sendAllItem(dataToSend).then((res) => {
      props.updateChecksAfterResponse(res);
      props.setNotification({
        type: 'success',
        message: SUCCESS_MESSAGE.SENT_ITEM_SUCCESS_MULTIPLE
      });
      props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`);
    }).catch((err) => {
      props.setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const clearMoveArray = () => {
    setMoveArray([]);
  };

  const handleRepeat = (data, array, type, isLinkedRepeat, changedUniqueId, linkedItems, step) => {
    let seatId;
    if (array.includes(-1)) {
      seatId = [];
    } else {
      seatId = [];
      array.forEach((e) => {
        props.check.seats.forEach((d) => {
          if (d.open && e === d.number) {
            seatId.push(d.id);
          }
        });
      });
    }

    let modifierCopy;
    const selectedItems = getObjectValue(() => props.check.orders[0].items, []).reduce((a, v) => {
      if (type === 'unsent' ? data.some((d) => d.id === v.id) : data.some((d) => d.id === v.checkItemId)) {
        const it = type === 'unsent' ? data.find((d) => d.id === v.id) : data.find((d) => d.id === v.checkItemId);
        const item = JSON.parse(v.orderJson);
        const modifierJson = JSON.parse(item.modifierJson);
        if (modifierJson) {
          modifierJson.seatIds = seatId;
          modifierJson.price = it.price;
        }
        a.push({
          ...item,
          price: it.price || item.price,
          seatIds: seatId,
          modifierJson: JSON.stringify({ ...modifierJson, seatIds: seatId }),
          checkOrderItemId: type === 'unsent' ? v.id : v.checkItemId,
          pending: true,
          menuTypeId: modifierJson && modifierJson.menuTypeId,
          id: type === 'unsent' ? v.id : v.checkItemId
        });
      }
      return a;
    }, []);
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: props.check.id,
      employeeCard: props.userInfo.employeeCard,
      items: selectedItems,
      orderJson: JSON.stringify(selectedItems),
      latitude: '0',
      longitude: '0',
      geoLocation: '0'
    };
    if (isLinkedRepeat && data.some((e) => e.hasLinkedMenuItem)) {
      const dataToSendCopy = { ...selectedItems[0] };
      dataToSendCopy.modifiers = JSON.parse(dataToSendCopy.modifierJson).modifierData;
      let cartItemCopy = updateExcludeModifier([dataToSendCopy]);
      cartItemCopy = applyModFunction(cartItemCopy);
      const modifierObjectCopy = getObjectValue(() => mapStringCartToObject(cartItemCopy, [], props.modifiersHashTable, props.modifierGroupsHashTable)[0].modifiers, []);
      modifierCopy = modifierObjectCopy.filter((e) => e.modifierGroupId);
    }
    props.addChecks(dataToSend, 'add', isLoaderRequried).then((result) => {
      props.updateChecksAfterResponse(result);
      props.setSeat(result);
      const cartData = selectedItems.map((item, index) => {
        const responseObj = getObjectValue(() => result.orders[0], []).items[result.orders[0].items.length - (index + 1)];
        return {
          // ...item,
          ...getObjectValue(() => JSON.parse(item.modifierJson), {}),
          id: responseObj.id,
          checkItemId: responseObj.checkItemId,
          modifiers: isLinkedRepeat && modifierCopy ? modifierCopy : getObjectValue(() => JSON.parse(item.modifierJson).modifiers, {}),
          uniqueIdForLinkedItem: changedUniqueId
        };
      });
      props.addToCart(cartData);
      if (linkedItems && step !== linkedItems.length - 1) {
        handleRepeat([linkedItems[step + 1]], array, type, true, changedUniqueId, linkedItems, step + 1);
      }
    }).catch((err) => {
      props.setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const handleRepeatData = (data, array, type) => {
    if (data.some((e) => e.hasLinkedMenuItem)) {
      const linkedRepeatItems = props.cart.filter((c) => data.some((d) => d.uniqueIdForLinkedItem === c.uniqueIdForLinkedItem));
      const changedUniqueId = uuidv4();
      handleRepeat([linkedRepeatItems[0]], array, type, true, changedUniqueId, linkedRepeatItems, 0);
    } else {
      handleRepeat(data, array, type, false);
    }
  };

  const swipeDisplaySeats = props.check?.seats ? sort(props.check.seats, 'number').filter((e) => e.open) : [];
  const seatsPerPage = 5;

  const displaySwipeStyle = (index, lastIndex, foundIndex) => {
    let moreSeats = false;
    if (swipeDisplaySeats.length > 5 && ((index === lastIndex && foundIndex !== Number(swipeDisplaySeats.length - 1)) || (foundIndex > 1 && index === 0))) {
      moreSeats = true;
    } else {
      moreSeats = false;
    }
    return moreSeats;
  };

  const handleSwipeDisplaySeatSet = (index, lIndex, foundIndex) => {
    const firstIndex = (swipeDisplaySeats.length <= 5 || index < 0) ? 0 : index;
    const lastIndex = (swipeDisplaySeats.length <= 5 || index < 0) ? seatsPerPage : lIndex;
    const currentSeats = swipeDisplaySeats.slice(firstIndex, lastIndex);
    setCurrentSwipedSeats(currentSeats.map((e, i) => {
      return {
        ...e,
        moreSeats: displaySwipeStyle(i, Number(currentSeats.length - 1), foundIndex)
      };
    }));
  };

  useLayoutEffect(() => {
    const foundIndex = swipeDisplaySeats.findIndex((e) => e.id === (props.position.id));
    handleSwipeDisplaySeatSet(foundIndex - 2, foundIndex + 3, foundIndex);
  }, [props.check?.seats]);

  const handleSwipeCart = (type) => {
    const foundIndex = swipeDisplaySeats.findIndex((e) => e.id === props.position.id);
    if (type === 'right' && foundIndex <= 0) {
      props.setPosition(foundIndex === 0 ? { number: -1, position: -1 } : swipeDisplaySeats[swipeDisplaySeats.length - 1]);
    }
    if (type === 'left' && foundIndex === Number(swipeDisplaySeats.length - 1)) {
      props.setPosition({ number: -1, position: -1 });
    }
    if (type === 'left' && foundIndex < Number(swipeDisplaySeats.length - 1)) {
      props.setPosition(swipeDisplaySeats[foundIndex + 1]);
      if (currentSwipedSeats.findIndex((e) => e.id === swipeDisplaySeats[foundIndex + 1].id) >= 3) {
        handleSwipeDisplaySeatSet(foundIndex - 2, foundIndex + 3, foundIndex + 1);
      }
    } else if (type === 'right' && foundIndex > 0) {
      props.setPosition(swipeDisplaySeats[foundIndex - 1]);
      if (currentSwipedSeats.findIndex((e) => e.id === swipeDisplaySeats[foundIndex - 1].id) < 2) {
        handleSwipeDisplaySeatSet(foundIndex - 2, foundIndex + 3, foundIndex);
      }
    }
  };
  const handleSeatClick = (item) => {
    setShowBtn(item.number);
    addSeatData(item, 'seat');
    const foundIndex = swipeDisplaySeats.findIndex((e) => e.id === item.id);
    handleSwipeDisplaySeatSet(foundIndex - 2, foundIndex + 3, foundIndex);
  };

  const handleMangerAuthentication = () => {
    if(props.userInfo && props.userInfo.jobTypeId !==1) {
      props.openManagerCheck();
    } else {
      setIsVoidOpen(true)
    }
  };

  const submitCheckName = () => {
    setIsCheckNameModalOpen(false);
    const dataToSend = {
      checkHeaderId: props.check.id,
      name: tabName
    };
    props.updateCheckName(JSON.stringify(dataToSend)).then((res) => {
      props.updateSeatInfo(res);
    });
  };

  const handleKioskPriceCheck = () => {
    const data = getObjectValue(() => props.check.orders[0].items.reduce((a, v) => {
      if (v.pending) {
        a.push({
          ...v,
          ...JSON.parse(v.orderJson),
          menuScreenId: getObjectValue(() => JSON.parse(JSON.parse(v.orderJson).menuScreenId), 0),
          menuId: getObjectValue(() => JSON.parse(JSON.parse(v.orderJson).menuId), 0)
        });
      }
      return a;
    }, []), []);
    let subtotalAmount = 0;
    const items = data && data.length > 0 ? data.map((e) => {
      subtotalAmount += e.price;
      return {
        menuItemId: e.menuItemId,
        quantity: e.quantity,
        modifiers: e.modifiers,
        price: e.price,
        note: e.note,
        menuScreenId: e.menuScreenId,
        menuId: e.menuId
      };
    }) : [];
    const dataToSend = {
      deviceId: props.deviceInfo.deviceId,
      employeeId: Number(props.userInfo.id),
      storeId: props.deviceInfo.storeId,
      checkHeaderId: props.check.id,
      items,
      subtotalAmount
    };
    props.priceCheck(dataToSend).then((resData) => {
      props.setSeat({
        ...props.check,
        ...resData,
        items: data
      });
    }).catch((err) => {
      props.setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  return (
    <div className={cn('col-12 p-0 h-100', ['kiosk'].includes(flowType()) ? '' : 'overflowY')}>
      {isServerApp && (
        <div className="row m-0 p-0 h-10">
          <div className="col-3 fs-12 col-md-2 col-lg-2 p-0 m-0 align-items-center h-100">
            <div className="flex-column od-text-primary">
              <div>#{props.check.number}</div>
              <div className={((props.check.stationName && props.check.stationName.length > 15) || (props.check.name && props.check.name.length > 15)) && 'fs-14'}>TBL : {props.check.stationName || props.check.name || props.check.stationNumber}</div>
              {isServerApp && !props.check.tab && (
              <div className="row p-0 m-0 px-1">
                {props.check.tabName && (<span className={style.checkName}>{props.check.tabName}</span>)}
                <button type="button" className={cn(style.removeBtnStyle, 'btn p-0')} onClick={() => setIsCheckNameModalOpen(true)} aria-label="editBtn">
                  <i className="fas fa-edit od-text-primary" aria-hidden="true" />
                </button>
              </div>
              )}
            </div>
          </div>
          <div className="col-6 col-md-8 col-lg-8 p-0 m-0 h-100">
            {isServerApp && isDefaultMode && (
            <div className="d-flex overflowX col-12 p-0 fs-12">
              <div className="px-1">
                <div role="presentation" onClick={() => { addSeatData({}, 'table'); setShowBtn(-1); }} className={cn(props.position.number === -1 ? 'btn-primary od-btn-primary' : 'btn-secondary od-btn-secondary', 'rounded color-white px-3 py-1 text-center fs-16 ')}>{LABEL().TABLE}</div>
              </div>
              {props.check && props.check.seats && props.check.seats.length > 0 && sort(props.check.seats, 'number').map((item) => {
                return (
                  <div key={item.id} className="d-flex">
                    {item.open && (
                    <div className="pr-2">
                      <div role="presentation" onClick={() => { handleSeatClick(item); }} className={cn(style.btnBorderWhite, Number(showBtn) !== item.number ? 'btn-secondary od-btn-secondary' : 'btn-primary od-btn-primary', 'text-center py-1 px-2 rounded fs-16 color-white')}>{item.number}</div>
                      {Number(showBtn) === item.number ? seatBtn && seatBtn.map((btn) => {
                        return (
                          <div
                            key={btn.name}
                            role="presentation"
                            onClick={() => { btn.click(item); }}
                            className={cn('text-center fs-14 btn-primary btn-ripple rounded od-btn-primary fw-700 px-2 my-1')}
                          >
                            {btn.name}
                          </div>
                        );
                      }) : null}
                    </div>
                    )}
                  </div>
                );
              })}
              <div className={cn('od-app-background-color background-primary', seats.seats && seats.seats.length > 13 ? style.btnFixedEnd : '')}>
                <button type="button" className={cn(style.btnStyle, style.secondaryBtn, style.btnAddStyle, 'fs-12 btn-secondary od-inc-font-btn-color od-inc-counter-btn-color', seats.seats && seats.seats.length > 12 && style.plusIcon, 'position-fixed')} onClick={() => setIsModalOpen(true)} aria-label="plusBtn">
                  <i className="fa fa-plus va-m" />
                </button>
              </div>
            </div>
            )}
          </div>
          <div className="col-3 col-md-2 col-lg-2 p-1 row mx-0 justify-content-center">
            <div className="col-6 col-md-6 p-0 text-right">
              {!isSearch && <i role="presentation" className="od-text-primary fa fa-search fs-30" aria-hidden="true" onClick={() => setIsSearch(true)} /> }
              <Search isSearch={isSearch} onChange={onSearchChange} onClose={() => setIsSearch(false)} isTop />
            </div>
            {!isKiosk && (
              <div className="col-6 col-md-6 p-0 fs-30 h-0 text-right" role="presentation" onClick={() => handleCancelOrderConfirm()}><i className="fa fa-times od-text-primary" aria-hidden="true" /></div>
            )}
          </div>
        </div>
      )}
      {isTableTop && (
        <div className="col-12 p-0 row mx-0 h-8 fs-20 od-text-primary text-primary">
          <div className="col-2 px-0 fs-12 h-100 px-1">
            <div>
              #{props.check.number}
            </div>
            <div>{LABEL().TBL} : {props.check.stationName || props.check.name || props.check.stationNumber}</div>
          </div>
          <div className="col-8 p-0 h-100">
            <SearchComponent onChange={onSearchChange} isTop />
          </div>
          <div className="col-2 px-1 h-100 row mx-0 align-items-center justify-content-end">
            <i
              role="presentation"
              onClick={() => handleCancelOrderConfirm()}
              className="fa fa-home"
              aria-hidden="true"
            />
          </div>
        </div>
      )}
      <Orders
        isHeight={props.isHeight}
        filteredItemsList={props.filteredItemsList}
        allMenusHashTable={props.allMenusHashTable}
        allScreensList={props.allScreensList}
        menus={props.menus}
        auth={props.auth}
        openPriceEdit={openPriceEdit}
        isModalOpen={isModalOpen}
        deletePop={deletePop}
        position={props.position}
        setOpenMovePopUp={setOpenMovePop}
        seat={props.check}
        deleteAll={deleteAll}
        goToPayment={goToPayment}
        sendAllItems={sendAllItems}
        closeDeleteAllPopup={closeDeleteAllPopup}
        submitSeatNumber={submitSeatNumber}
        validateSeatNumber={validateSeatNumber}
        menuItem={props.screenMenuItemsList}
        onClickMenu={getMenuItem}
        moveClick={moveClick}
        print={print}
        printPopUp={printPopUp}
        deleteAllPopUp={deleteAllPopUp}
        moveArray={moveArray}
        keyboard={keyboard}
        closeModal={closeModal}
        addToCart={isServerApp ? pushToOrder : orderDetailRoute}
        cartItemsInfo={props.cartItemsInfo}
        themeStyle={props.themeStyle}
        themeProperties={props.themeProperties}
        loading={loading}
        sendSingle={sendSingle}
        menuLoading={menuLoading}
        setSelectedToMove={setSelectedToMove}
        goToCart={goToCart}
        clearMoveArray={clearMoveArray}
        move={move}
        cart={props.cart}
        isStoreSelectionModal={props.isStoreSelectionModal}
        menusList={props.menusList}
        menuIndex={props.menuIndex}
        onSearch={onSearch}
        onSearchChange={onSearchChange}
        searchString={search}
        addToCartLoader={props.addToCartLoader}
        menuItemsHashTable={props.menuItemsHashTable}
        modifierGroupsHashTable={props.modifierGroupsHashTable}
        modifiersHashTable={props.modifiersHashTable}
        onRemoveItemFromCart={onRemoveItemFromCart}
        navigateTo={navigateTo}
        pushItemQuantityToCart={props.pushItemQuantityToCart}
        changeMenu={props.changeMenu}
        changeMenuByIndex={props.changeMenuByIndex}
        isBrowse={props.isBrowse}
        handleMenuChangeNavigation={handleMenuChangeNavigation}
        onModifyItem={onModifyItem}
        openMovePopUp={openMovePopUp}
        deleteItem={deleteItem}
        handleSelectStore={handleSelectStore}
        handleKioskCheckout={handleKioskCheckout}
        startOrderPopUp={startOrderPopUp}
        handleRoute={handleRoute}
        isPrintOpen={props.isPrintOpen}
        printData={props.printData}
        handleRepeatData={handleRepeatData}
        handleSwipeCart={handleSwipeCart}
        selectedSeat={showBtn}
        currentSwipedSeats={currentSwipedSeats}
        clearId={clearId}
        highlightedCartItems={props.highlightedCartItems}
        checkOut={checkOut}
        handleVoidItems={handleVoidItems}
        handleMangerAuthentication={handleMangerAuthentication}
        setVoidItemData={setVoidItemData}
        setIsVoidOpen={setIsVoidOpen}
        isVoidOpen={isVoidOpen}
        deviceInfo={props.deviceInfo}
        handleKioskPriceCheck={handleKioskPriceCheck}
      />
      {props.isManagerCheck && <ManagerCheck flowType = {flowType()} {...props} setIsVoidOpen={setIsVoidOpen} />}
      <Modal
        isOpen={isClearPopUp}
        isModalCenter
      >
        <div className="col-12 my-2 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
          <div className="p-1 position-absolute" style={{ right: '5px', top: '0px' }}>
            <div className="fs-24" role="presentation" onClick={() => { setClearPopUp(false); }}>
              <i className="fa fa-times" aria-hidden="true" />
            </div>
          </div>
          <div className="col-12 fs-18 mt-10 fw-700 text-center">
            <div>{CUSTOM_MESSAGES().CLEAR_ALL_FROM_SEAT}</div>
          </div>
          <div className="col-12 d-flex justify-content-center">
            <button type="submit" className="col-4 m-2 btn btn-secondary od-btn-secondary" onClick={() => setClearPopUp(false)}>
              <div className="fs-18">{LABEL().NO}</div>
            </button>
            <button type="submit" className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary" onClick={() => { setClearPopUp(false); handleClear(clearId); }}>
              <div className="fs-18">{LABEL().YES}</div>
            </button>
          </div>
        </div>
      </Modal>
      <Modal isOpen={isSelectedCard.open} isModalCenter customClass2={style.maxWidth}>
        <div className="col-12 px-0 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
          <div className="col-12 fs-18 fw-700 text-center px-0">
            <KioskCart menuItemId={isSelectedCard.menuItemId} />
          </div>
          <div className="col-12 p-4 justify-content-center">
            <button type="submit" className="col-12 w-100 btn100 btn-primary btn-ripple od-btn-primary" onClick={() => setIsSelectedCard({ ...isSelectedCard, open: false })}>
              <div className="fs-30">{LABEL().KIOSK_CLOSE}</div>
            </button>
          </div>
        </div>
      </Modal>
      <Modal isOpen={isCheckNameModalOpen}>
        <div className="col-12 my-2 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
          <div
            className="px-2 text-right"
          >
            <i className="fa fa-times fs-24" aria-hidden="true" role="presentation" onClick={() => { setIsCheckNameModalOpen(false); }} />
          </div>
          {isCheckNameModalOpen && (
            <Formik
              initialValues={{ checkName: tabName, isEdit: false }}
            >
              {() => {
                return (
                  <Form>
                    <KeyboardInput
                      name="checkName"
                      type="text"
                      isOpen={isCheckNameModalOpen}
                      value={tabName}
                      customClass="mt-2"
                      onChange={(val) => setTabName(val)}
                      // className="p-2 w-100"
                      placeholder={CUSTOM_MESSAGES().ENTER_CHECK_NAME}
                      // maxLength={20 || noteLength}
                    />
                    <button
                      className={cn('w-100 mt-2 btn btn-primary btn-ripple od-btn-primary')}
                      type="submit"
                      style={{ height: '10vh' }}
                      onClick={() => { submitCheckName(); }}
                    >
                      <div className="fs-18">{LABEL().SUBMIT}</div>
                    </button>
                  </Form>
                );
              }}
            </Formik>
          )}
        </div>
      </Modal>
      <Modal
        isOpen={cancelOrderConfirm}
        isModalCenter
      >
        <div className="col-12 px-0 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
          <div className="px-2 text-right fs-24">
            <i
              role="presentation"
              onClick={() => { setCancelOrderConfirm(false); }}
              className="fa fa-times"
              aria-hidden="true"
            />
          </div>
          <div className="col-12 fs-18 fw-700 text-center">
            {CUSTOM_MESSAGES().CANCEL_ORDER}
          </div>
          <div className="col-12 d-flex justify-content-center">
            <button type="submit" className="col-4 m-2 btn btn-secondary od-btn-secondary" onClick={() => setCancelOrderConfirm(false)}>
              <div className="fs-18">{LABEL().NO}</div>
            </button>
            <button type="submit" className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary" onClick={() => { goToChecks(); }}>
              <div className="fs-18">{LABEL().YES}</div>
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = ({
  orders,
  oauth,
  header,
  theme,
  checks,
  notification,
  storeChecks
}) => ({
  deviceInfo: oauth.deviceInformation,
  userInfo: oauth.loggedInUserData,
  auth: oauth.authInfo,
  loading: orders.loading || checks.loading || storeChecks.loading,
  menuLoading: orders.menuLoading,
  addToCartLoader: orders.addToCartLoader,
  menus: orders.menus,
  cart: orders.cart,
  screenMenuItemsList: orders.screenMenuItemsList,
  cartItemsInfo: orders.cartItemsInfo,
  multiCartInfo: orders.multiCartInfo,
  cancelOnPage: header.cancelOnPage,
  themeStyle: theme.styles,
  menusHashTable: orders.menusHashTable,
  action: header.action,
  menuOptions: orders.menuOptions,
  menuIndex: orders.menuIndex,
  menusList: orders.menusList,
  menuLabel: header.menuLabel,
  menuCard: orders.menuCardList,
  menuItemsHashTable: orders.menuItemsHashTable,
  modifierGroupsHashTable: orders.modifierGroupsHashTable,
  modifiersHashTable: orders.modifiersHashTable,
  isBrowse: header.footerItemsType === 1,
  favouriteItems: orders.favouriteItems,
  favoutiteLoading: orders.addToFavouriteLoader,
  isGetMenuLoaded: orders.isGetMenuLoaded,
  themeProperties: theme.themeProperties,
  isUpsellLoading: orders.isUpsellLoading,
  activeMenuItemId: Number(urlSearchParams('menuId')) || (orders.menusList[orders.menuIndex] && orders.menusList[orders.menuIndex].id) || 0,
  check: orders.seats,
  position: orders.position,
  isPrintOpen: notification.isPrintOpen,
  printData: notification.printData,
  highlightedCartItems: orders.highlightedCartItems,
  isManagerCheck: oauth.isManagerCheck,
  modifierData: orders.modifierData,
  allScreensList: orders.allScreensList,
  allMenusHashTable: orders.allMenusHashTable,
  filteredItemsList: orders.filteredItemsList,
  isHeight: orders.isHeight
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getMenu,
  openStartOrderPopUp,
  clearCart,
  setPrintNotification,
  stopNotificationSound,
  logout,
  pushMenuItemsByScreenId,
  pushCartItemsInfo,
  printing,
  removeSeat,
  replaceCart,
  onSearchItem,
  getStoreThemeUrl,
  upsellCheck,
  addToCart,
  removeItemFromCart,
  pushItemQuantityToCart,
  changeMenuByIndex,
  changeMenu,
  orderItems,
  updateMultiCart,
  clearMenu,
  setNotification,
  occupySeat,
  setSeat,
  setPosition,
  addToChecks,
  addChecks,
  updateChecksAfterResponse,
  deleteItm,
  editCartItem,
  deleteAllItems,
  closePrintNotification,
  sendAllItem,
  singleSend,
  moveChecks,
  seatClear,
  pushCartItems,
  setPaymentCheck,
  updateCartAfterNote,
  updateCheckName,
  voidItm,
  openManagerCheck,
  updateSeatInfo,
  removePaymentCheck,
  clearAuthResponse,
  setHighlightCartItems,
  syncCheckForPayment,
  checkVoid,
  setInActivityStatus,
  priceCheck,
  updateCheckAfterPriceCheck,
  enableStartOverBtn
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MenuOrder);
